module.exports = __webpack_public_path__ + "media/coffee.f92e8d1b.mp4";